export default "__VITE_ASSET__CrdKOT$X__"